// extracted by mini-css-extract-plugin
export default {"container":"FilesPreview_container__OHtiK","file":"FilesPreview_file__5-xZA","image":"FilesPreview_image__zlQj7"};